import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../../context/LoaderContext";
import {TranslateContext} from "../../../context/TranslateContext";
import LabelErroreCampo from "../../../components/LabelErroreCampo";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import NsBtnBack from "../../../components/buttons/NsBtnBack";
import {aggiornaAgenziaApi, aggiungiAgenziaApi, getAgenziaByIdApi} from "../../../services/UtentiServices";

export default function ModificaAgenzia() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getAgenzie() {
        startChiamata();
        const response = await getAgenziaByIdApi(id);
        let val = response.data.data;
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_agenzia", val.id_agenzia);
            formikRef.current.setFieldValue("descrizione", val.descrizione);
            formikRef.current.setFieldValue("abarth", val.abarth);
        }
        endChiamata();
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getAgenzie();
            }
        }
    }, [id]);

    const SignupSchema = Yup.object().shape({
        descrizione: Yup.string()
            .max(80, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
        abarth: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    async function aggiornaAgenzia(values) {
        startChiamata();
        const response = await aggiornaAgenziaApi(id, values);
        endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiAgenzia(values) {
        startChiamata();
        const response = await aggiungiAgenziaApi(values);
        endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    return (
        <Card
            icon={'fas fa-users'}
            title={id ? 'Modifica Agenzia' : 'Inserisci Agenzia'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }
        >
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_agenzia: '',
                    descrizione: '',
                    abath: ''
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    if (id) {
                        aggiornaAgenzia(values);
                    } else {
                        aggiungiAgenzia(values);
                    }
                }}
            >
                {({errors, touched, submitCount, values}) => (
                    <Form className="row g-3">
                        <div className="col-md-6">
                            <label htmlFor="descrizione" className="form-label">Nome Agenzia*:</label>
                            <Field
                                name="descrizione"
                                className="form-control"
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"descrizione"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="abarth" className="form-label">Tipo di agenzia*:</label>
                            <Field
                                as={"select"}
                                name="abarth"
                                className="form-control form-select"
                                value={values['abarth']}
                                onChange={(event) => {
                                    formikRef.current.setFieldValue("abarth", event.target.value)
                                }}
                            >
                                <option value={''}></option>
                                <option value={'0'}>RFI</option>
                                <option value={'1'}>Abarth</option>
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"abarth"}
                                              submitCount={submitCount}/>
                        </div>

                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}